import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "deviceData-capability",
  "use": "deviceData-capability-usage",
  "viewBox": "0 0 16 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 14\" id=\"deviceData-capability\"><path d=\"M6 .9c.2-.5.9-.5 1 0V1l.6 9.2 1.6-4.6c.1-.4.7-.4.9-.1v.1l1 2.3.5-.8c.2-.1.3-.2.4-.2h3c.3 0 .5.2.5.5 0 .2-.2.4-.4.5h-2.7l-.9 1.3c-.2.3-.6.3-.8 0v-.1l-.9-2-2 5.8c-.2.5-.8.4-1 0v-.1l-.6-9L4.6 9c-.1.4-.7.4-.9.1V9l-.6-2.3-.9 1c-.1.1-.2.1-.3.1H1c-.3 0-.5-.2-.5-.5 0-.2.2-.4.4-.5h.7l1.3-1.5c.2-.3.7-.2.8.1v.1L4.2 7 6 .9z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/deviceData-capability.svg
// module id = YsAg
// module chunks = 6